// extracted by mini-css-extract-plugin
export var activeDot = "_40-c";
export var buttonContainer = "_40-9";
export var channelButton = "_40-a";
export var clickable = "_40-d";
export var content = "_40-0";
export var contentFull = "_40-2";
export var contentThird = "_40-1";
export var contentWrapper = "_40-7";
export var description = "_40-5";
export var heightShort = "_40-f";
export var image = "_40-3";
export var imageContainer = "_40-4";
export var selectButton = "_40-e";
export var spinnerContainer = "_40-b";
export var titleContent = "_40-8";
export var titleWrapper = "_40-6";